import { Alert, Box, Typography } from '@mui/material';
import { LightTooltip } from 'lib/designSystem/WhiteTooltip';
import { formatMoney } from 'lib/functions/utils';
import React from 'react';

interface CreditNoteAlertProps {
  creditNotesValue: number;
}

/**
 * Componente reutilizable para mostrar alerta de notas de crédito
 * Usado en DocumentsSelectorDialog y Editor
 */
const CreditNoteAlert: React.FC<CreditNoteAlertProps> = ({
  creditNotesValue,
}) => {
  const isWarning = creditNotesValue > 0;
  const alertProps = isWarning
    ? {
        severity: 'warning' as const,
        tooltip: (
          <Box p={1}>
            <Typography fontSize={16}>
              {`Contiene Notas de crédito por: ${formatMoney(creditNotesValue)}`}
            </Typography>
          </Box>
        ),
      }
    : {
        severity: 'success' as const,
        tooltip: (
          <Box p={1}>
            <Typography fontSize={16}>No hay notas de crédito.</Typography>
          </Box>
        ),
      };
  return (
    <LightTooltip title={alertProps.tooltip} placement="top">
      <span>
        <Alert
          severity={alertProps.severity}
          sx={{
            maxWidth: '20px',
            minWidth: '20px',
            height: '20px',
            p: 0,
            m: 0,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            '& .MuiAlert-icon': {
              fontSize: '1rem',
              m: 0,
            },
          }}
        />
      </span>
    </LightTooltip>
  );
};

export default CreditNoteAlert;
